
export default function MaintenanceSection() {
  return (
    <div
      style={{
        fontFamily: "ui-sans-serif, system-ui, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", Segoe UI Symbol, \"Noto Color Emoji\";",
        margin: 0,
        padding: 0,
        height: "100vh",
        width: "100vw",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        className="maintenance-container"
        style={{
          flexDirection: "column",
          textAlign: "center",
          width: "90%",
        }}
      >
        <img
          src="/img/logo_header.png"
          alt="Your Logo"
          className="logo"
          style={{
            maxWidth: "250px",
            marginBottom: "20px",
            textAlign: "center",
            margin: "20px auto",
          }}
        />

        <p
          style={{
            fontFamily: "ui-sans-serif, system-ui, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", Segoe UI Symbol, \"Noto Color Emoji\";",
            color: "#000",
            fontSize: "16px",
            lineHeight: "1.5",
          }}
        >
          We're upgrading our technology, Check back soon!
        </p>

        <a
          href="mailto:info@megamode.com.au"
          style={{ textDecoration: "none" }}
        >
          <p
            style={{
              fontFamily: "ui-sans-serif, system-ui, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", Segoe UI Symbol, \"Noto Color Emoji\";",
              color: "#000",
              fontSize: "16px",
              lineHeight: "1.5",
            }}
          >
            Contact
          </p>
        </a>
      </div>
    </div>
  );
}
